/* ==========================================
   HOME STANDARD — DIRECT QUICK ADD

   Selected variant → Add to cart → Cart page

   Compatible with:
   - Shopify Craft
   - Home Standard variant thumbnails
   - Single-variant products
   - Multi-variant products
   ========================================== */

(function () {
  "use strict";

  if (window.HSDirectQuickAddLoaded) return;
  window.HSDirectQuickAddLoaded = true;

  /* ==========================================
     QUICK ADD CLICK HANDLER
     ========================================== */

  document.addEventListener(
    "click",
    async function (event) {

      const button = event.target.closest(
        ".hs-card .quick-add .quick-add__submit"
      );

      if (!button) return;

      /* Prevent product page navigation */

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      /* Prevent duplicate clicks */

      if (button.dataset.hsLoading === "true") {
        return;
      }

      const card = button.closest("[data-hs-card]");

      if (!card) return;

      /* ==========================================
         FIND SELECTED VARIANT
         ========================================== */

      let variantId = null;

      /* First priority: selected thumbnail */

      const selectedThumbnail = card.querySelector(
        '[data-hs-variant][aria-pressed="true"], ' +
        '[data-hs-variant].hs-variant-selected, ' +
        '[data-hs-variant].is-active'
      );

      if (selectedThumbnail) {

        variantId =
          selectedThumbnail.dataset.variantId ||
          selectedThumbnail.dataset.id;

      }

      /* Second priority: Shopify product form */

      if (!variantId) {

        const variantInput = card.querySelector(
          'input[name="id"].product-variant-id'
        );

        if (variantInput) {
          variantId = variantInput.value;
        }

      }

      /* Third priority: first available thumbnail */

      if (!variantId) {

        const firstVariant = card.querySelector(
          '[data-hs-variant]:not(.is-unavailable)'
        );

        if (firstVariant) {

          variantId =
            firstVariant.dataset.variantId ||
            firstVariant.dataset.id;

        }

      }

      /* ==========================================
         VALIDATE VARIANT
         ========================================== */

      if (!variantId || !/^\d+$/.test(String(variantId))) {

        console.error(
          "HOME STANDARD: No valid variant ID found.",
          card
        );

        alert("Unable to identify this product. Please try again.");

        return;
      }

      /* Prevent adding unavailable variants */

      if (
        selectedThumbnail &&
        selectedThumbnail.classList.contains("is-unavailable")
      ) {

        alert("This variant is currently sold out.");

        return;

      }

      /* ==========================================
         BUTTON LOADING STATE
         ========================================== */

      button.dataset.hsLoading = "true";

      button.disabled = true;

      const originalHTML = button.innerHTML;

      button.textContent = "Adding...";

      /* ==========================================
         ADD PRODUCT TO SHOPIFY CART
         ========================================== */

      try {

        const root = window.Shopify?.routes?.root || "/";

        const cartAddURL = root + "cart/add.js";

        const response = await fetch(cartAddURL, {

          method: "POST",

          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },

          body: JSON.stringify({

            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]

          })

        });

        const result = await response.json();

        if (!response.ok) {

          throw new Error(
            result.description ||
            result.message ||
            "Unable to add product to cart."
          );

        }

        /* ==========================================
           SUCCESS — GO DIRECTLY TO CART
           ========================================== */

        window.location.assign(root + "cart");

      } catch (error) {

        console.error(
          "HOME STANDARD QUICK ADD ERROR:",
          error
        );

        alert(
          error.message ||
          "Something went wrong. Please try again."
        );

        /* Restore button */

        button.innerHTML = originalHTML;

        button.disabled = false;

        button.dataset.hsLoading = "false";

      }

    },
    true
  );

})();